export interface IEventUpgradesResponse {
  Name?: string
  Description?: string
  GuestCount?: number
  ImageURL?: string
  PurchaseLink?: string
  ProductLink?: string
}

export class EventUpgradePackage {
  name?: string
  description?: string
  guestCount?: number
  imageUrl?: string
  purchaseLink?: string
  productLink?: string

  constructor(upgradePackage: Partial<EventUpgradePackage>) {
    this.name = upgradePackage.name ?? "—"
    this.description = upgradePackage.description
    this.guestCount = upgradePackage.guestCount
    this.imageUrl = upgradePackage.imageUrl
    this.purchaseLink = upgradePackage.purchaseLink
    this.productLink = upgradePackage.productLink
  }

  public static fromResponse(response: IEventUpgradesResponse): EventUpgradePackage {
    return new EventUpgradePackage({
      name: response.Name,
      description: response.Description,
      guestCount: response.GuestCount,
      imageUrl: response.ImageURL,
      purchaseLink: response.PurchaseLink,
      productLink: response.ProductLink,
    })
  }
}
